import { ThemeMode } from "@/src/types/digitalData";

const COLOR_SCHEME_STORAGE_KEY = "baanaColorScheme";

export const getInitialThemeMode = (): ThemeMode => {
  try {
    const stored = localStorage.getItem(COLOR_SCHEME_STORAGE_KEY);
    if (stored === "light" || stored === "dark") {
      return stored;
    }
  } catch {
    // localStorage can throw in private mode; fall through to media query
  }

  if (
    typeof globalThis.matchMedia === "function" &&
    globalThis.matchMedia("(prefers-color-scheme: dark)").matches
  ) {
    return "dark";
  }

  return "light";
};

export const setDigitalDataThemeMode = (themeMode: ThemeMode): void => {
  const digitalData = globalThis.digitalData;
  if (!digitalData) {
    return;
  }

  const user = digitalData.user[0];
  if (user) {
    user.themeMode = themeMode;
  }

  digitalData.page.attributes.themeMode = themeMode;
};
